// Internal modules
import { logger } from '../logger';
import { isFunction } from '@/lib/utils/typeUtils';
const kebabToCamelCase = (s: string): string => {
  return s.replace(/-(\w)/g, (_, match) => match.toUpperCase());
};

const logPerformanceTiming = (): void => {
  /**
   * PerformanceNavigationTiming API is not available in some
   * browsers (e.g. IE 11, Safari). For those browsers we fallback
   * to the older window.performance.timing object, which is an instance
   * of PerformanceTiming.
   */
  if (
    isFunction(window.PerformanceNavigationTiming) &&
    isFunction(window.performance?.getEntriesByType)
  ) {
    const [navTiming] = performance.getEntriesByType('navigation') || [];
    const paintTimings = performance.getEntriesByType('paint') || [];

    if (!navTiming) {
      logger.info('performance_navigation_timing_event_not_found');
      return;
    }

    const {
      domComplete,
      domInteractive,
      requestStart,
      responseEnd,
      responseStart,
    } = navTiming as PerformanceNavigationTiming;
    const paintTimingData = paintTimings.reduce(
      (obj, item) => ({
        ...obj,
        // 'first-paint', 'first-contentful-paint'
        [kebabToCamelCase(item.name)]: item.startTime,
      }),
      {},
    );
    const payload = {
      domComplete,
      domInteractive,
      firstByte: responseStart - requestStart,
      serverRequestTime: responseEnd - requestStart,
      source: 'PerformanceNavigationTiming',
      ...paintTimingData,
    };

    logger.info('performance_load_time', payload);
  } else if (window.performance?.timing) {
    // ! performance.timing is deprecated, it needs to be replaced
    // https://developer.mozilla.org/en-US/docs/Web/API/Performance/timing
    const {
      domComplete,
      domContentLoadedEventEnd,
      domInteractive,
      navigationStart,
      requestStart,
      responseEnd,
      responseStart,
    } = performance.timing;
    // domComplete is 0 in Safari
    const complete = domComplete || domContentLoadedEventEnd;

    logger.info('performance_load_time', {
      domComplete: complete - navigationStart,
      domInteractive: domInteractive - navigationStart,
      firstByte: responseStart - requestStart,
      serverRequestTime: responseEnd - requestStart,
      source: 'PerformanceTiming',
    });
  } else {
    logger.info('performance_apis_not_available');
  }
};

export const logPerformanceTimingOnLoadEvent = (): void => {
  window.addEventListener('load', logPerformanceTiming);
};
